module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Config")])], 1), _vm._v(" "), (_vm.m) ? _c('div', {
    staticClass: "linux-config project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Security Mode")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.m.safe.network_safe_mode) ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (!_vm.m.safe.network_safe_mode) ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("CloudLinker Authentication")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [(_vm.m.resource.csos_check === 'open') ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check !== 'open') ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("("), _c('translate', [_vm._v("When permissions is enabled, webssh does not support KEY authentication.")]), _vm._v(")")], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', {
    staticClass: "l-h-16"
  }, [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Destination Host Authentication")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.m.resource.autologin === 1) ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.autologin !== 1) ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e()])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": _vm.setDefaultUsername
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f1038c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/linux-config.vue
// module id = 550
// module chunks = 4 5 6